import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'react-bootstrap'
import styled from 'styled-components'
import requiredIf from 'react-required-if'

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 1.6rem;
    padding: 1rem;
  }
  .modal-header {
    border-bottom: none;
    .modal-title {
      line-height: 1.25;
      font-size: 1.25rem;
    }
  }
  .modal-footer {
    border-top: none;
  }
`

/** A modal to confirm or cancel the action described in the title and body */
const ConfirmModal = ({ alert, show, title, body, onConfirm, onCancel }) => (
  <StyledModal
    show={show}
    onHide={onCancel}
    aria-labelledby='confirmTitle'
    aria-describedby='confirmDescription'
    centered
  >
    <Modal.Header closeButton>
      <Modal.Title id='confirmTitle'>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body id='confirmDescription' className='py-0'>
      {body}
    </Modal.Body>
    <Modal.Footer>
      {alert ? (
        <Button variant='secondary' onClick={onCancel}>
          OK
        </Button>
      ) : (
        <>
          <Button variant='secondary' onClick={onConfirm}>
            Confirm
          </Button>
          <Button variant='outline-dark' onClick={onCancel}>
            Cancel
          </Button>
        </>
      )}
    </Modal.Footer>
  </StyledModal>
)

ConfirmModal.propTypes = {
  /** if true, displays only 'ok' button which calls onCancel */
  alert: PropTypes.bool,
  /** display or hide the modal */
  show: PropTypes.bool,
  /** bolded summary text at top of modal */
  title: PropTypes.string.isRequired,
  /** detail text for body of modal */
  body: PropTypes.node.isRequired,
  /** handler for confirmation button */
  onConfirm: requiredIf(PropTypes.func, (props) => !props.alert),
  /** handler for cancel button */
  onCancel: PropTypes.func.isRequired
}

export { ConfirmModal }
